import axios from 'axios';
import { getBackendUrl } from '../config';
import { triggerCookieProblemModal } from '../components/CookieProblemModal';
import { clearHeaderTooLargeModalShown, setHadCookieError } from '../utils/storageCleanup';

/** Error code when Nginx returns "Request Header Or Cookie Too Large" (400/413/431). */
export const ERR_HEADER_OR_COOKIE_TOO_LARGE = 'ERR_HEADER_OR_COOKIE_TOO_LARGE';

const NGINX_HEADER_TOO_LARGE_PATTERN = /request header or cookie too large/i;

function isHeaderOrCookieTooLargeResponse(response) {
  if (!response) return false;
  const status = response.status;
  if (status !== 400 && status !== 413 && status !== 431) return false;
  const data = response.data;
  const body = typeof data === 'string' ? data : (data && String(data)) || '';
  const isHtml = /<\s*html\s*[\s>]/i.test(body) || /<\s*!DOCTYPE\s+/i.test(body);
  return isHtml && NGINX_HEADER_TOO_LARGE_PATTERN.test(body);
}

let _cachedBaseURL;
function resolveBaseURL() {
  if (_cachedBaseURL !== undefined) return _cachedBaseURL;
  const runtime = getBackendUrl() || process.env.REACT_APP_BACKEND_URL;
  _cachedBaseURL = runtime ? String(runtime).replace(/\/$/, '') : null;
  return _cachedBaseURL;
}

const api = axios.create({});

export const openApi = axios.create({});

function withRuntimeBaseURL(config) {
  const baseURL = resolveBaseURL();
  if (!baseURL || config?.baseURL) return config;
  return { ...config, baseURL };
}

api.interceptors.request.use(withRuntimeBaseURL);
openApi.interceptors.request.use(withRuntimeBaseURL);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const response = error?.response;
    if (isHeaderOrCookieTooLargeResponse(response)) {
      const err = error;
      err.isHeaderOrCookieTooLarge = true;
      err.code = ERR_HEADER_OR_COOKIE_TOO_LARGE;
      setHadCookieError();
      triggerCookieProblemModal();
    }
    return Promise.reject(error);
  }
);

if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  window.__pingochatSimulateHeaderTooLarge = () => {
    clearHeaderTooLargeModalShown();
    triggerCookieProblemModal();
  };
}

export default api;
